import { call, put, takeLatest } from "redux-saga/effects";
import { httpRequest } from "../../../utils/networkCalls";
import { updateLoadingStatus } from "../../Loader/LoaderReducer";
import {
    AI_DESC_HIST_CALL,
    AI_DESC_HIST_DELETE,
    AI_DESC_HIST_HANDLE_ACTION_DESC,
    handleHistFetch,
    updateActionHistDesc,
} from "./HistoryReducer";
import { showToastMessage } from "../../../utils/common";
import { histCheckActRes, histSegregate } from "./HistoryUtils";

// Fetch History
export function* GetHist(action) {
    try {
        // Show Loader here
        yield put(updateLoadingStatus(true));

        // Call API
        const res = yield call(
            httpRequest,
            `/ai-marketing-hub/history?email=${action.payload?.user_email}`,
            "get"
        );

        const resObj = histSegregate(
            res?.data.reverse(),
            res?.video_data,
            res?.flyer_data
        );

        // Hide Loader here
        yield put(updateLoadingStatus(false));
        // Set Response in Reducer
        yield put(handleHistFetch({ history: resObj }));
    } catch (err) {
        throw err;
    }
}

// Delete History
export function* handleActionHistpDel(action) {
    try {
        // Show Loader here
        yield put(updateLoadingStatus(true));

        // Call API
        if (action.payload.category === "video") {

            yield call(httpRequest, `/automated_video/delete-record`, "delete", {
                oids: action.payload.delBody,
            });

        } else if (action.payload.category === "flyer") {

            yield call(httpRequest, "/banner_order/update",
                "post",
                { isActive: false, oid: action.payload.delBody[0] });

        } else {

            yield call(httpRequest, `/ai-marketing-hub/delete-record`, "delete", {
                oids: action.payload.delBody,
            });
        }

        const res = yield call(
            httpRequest,
            `/ai-marketing-hub/history?email=${action.payload?.user_email}`,
            "get"
        );

        const resObj = histSegregate(res?.data, res?.video_data, res?.flyer_data);

        // Hide Loader here
        yield put(updateLoadingStatus(false));

        // Set Response in Reducer
        yield put(handleHistFetch({ history: resObj }));
    } catch (err) {
        throw err;
    }
}

// Handle actions (like, dislike, save etc) description
export function* handleActionHistpDesc(action) {
    try {
        // Call API
        const res = yield call(
            httpRequest,
            `/ai-marketing-hub/update-description/${action.payload.gen_id}`,
            "patch",
            action.payload.actionInfo
        );

        // Check for response
        if (histCheckActRes(res, action)) {
            // Set Response in Reducer
            yield put(
                updateActionHistDesc({
                    pdTitle: action.payload.pastDesind,
                    descInd: action.payload.descInd,
                    subDescInd: action.payload.subDescInd,
                    actionInfo: action.payload.actionInfo,
                })
            );
            if (action.payload.actionInfo.hasOwnProperty("like_status")) {
                showToastMessage({
                    icon: "success",
                    mssge: "Thank you for your feedback!",
                    time: 3000,
                });
            } else {
                showToastMessage({
                    icon: "success",
                    mssge: "Changes Saved",
                    time: 3000,
                });
            }
        } else {
            showToastMessage({
                icon: "error",
                mssge: "Changes could not be Saved",
                time: 3000,
            });
        }
    } catch (err) {
        throw err;
    }
}

export function* sagaHistory(params) {
    // GetHist gets called when AI_DESC_HIST_CALL is dispatched
    yield takeLatest(AI_DESC_HIST_CALL, GetHist);
    yield takeLatest(AI_DESC_HIST_HANDLE_ACTION_DESC, handleActionHistpDesc);
    yield takeLatest(AI_DESC_HIST_DELETE, handleActionHistpDel);
}
